import { DlsTypographyVariants } from 'src/types/dls-typography-variants.enum';
import Selectors from 'src/utils/selectors';
import React from 'react';
import { TransactionType } from 'src/types/transaction-type.enum';
import { getTransactionTypeText } from 'src/utils/transactions.util';

interface Props {
    transactionType: TransactionType;
}

export default function TransactionTypeText({ transactionType }: Props): JSX.Element {
    return (
        <p className={DlsTypographyVariants.BODY_1} data-cy={Selectors.Transactions.TYPE_VALUE}>
            {getTransactionTypeText(transactionType)}
        </p>
    );
}
